import React, { useEffect, useState } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';
import { toast } from 'react-toastify';
import _ from 'lodash';

import { auth } from 'src/app/database';
import { getUserClaimsSelector } from 'src/store/app';
// import { getIssuerDataSelector } from 'src/store/issuer';

import { LoaderWrapper, LogoLoader } from 'src/components';

import { ROUTE } from 'src/constants/routes';

export const ProtectedRepRoute = () => {
  // const navigate = useNavigate();

  // const issuerData = useSelector(getIssuerDataSelector);
  const storedClaims = useSelector(getUserClaimsSelector);

  const [customClaims, setCustomClaims] = useState();

  const [firebaseUser, loadingFirebaseUser] = useAuthState(auth, {
    onUserChanged: async (user) => {
      if (_.isEmpty(storedClaims)) {
        const response = await user.getIdTokenResult();

        setCustomClaims(response?.claims);
      }
    },
  });

  useEffect(() => {
    if (!_.isEmpty(storedClaims)) {
      setCustomClaims(storedClaims);
    }
  }, [storedClaims]);

  useEffect(() => {
    if (!_.isEmpty(customClaims)) {
      if (customClaims?.user_type !== 'rep') {
        toast('You don`t have access to this page', { type: 'error' });
      }
    }
  }, [customClaims]);

  // useEffect(() => {
  //   if (!_.isEmpty(issuerData)) {
  //     if (_.isEmpty(issuerData?.lines)) {
  //       // toast('Please select your lines', { type: 'warning' });
  //       navigate('/issuer/settings?activeTab=profile');
  //     }
  //   }
  // }, [issuerData, navigate]);

  return loadingFirebaseUser ? (
    <LoaderWrapper>
      <LogoLoader />
    </LoaderWrapper>
  ) : firebaseUser && (customClaims?.user_type === 'rep' || storedClaims?.user_type === 'rep') ? (
    <Outlet />
  ) : (
    <Navigate to={ROUTE.ISSUER_LOGIN} />
  );
};
